import Phaser from 'phaser';
import { computeDesignSize, Palette } from '@core/config/constants';
import { BootScene } from '@core/scenes/BootScene';
import { PreloadScene } from '@core/scenes/PreloadScene';
import { HubScene } from '@scenes/HubScene';
import { CharacterSelectScene } from '@scenes/CharacterSelectScene';
import { StoreScene } from '@scenes/StoreScene';
import { ScenariosScene } from '@scenes/ScenariosScene';
import { AchievementsScene } from '@scenes/AchievementsScene';
import { MissionsScene } from '@scenes/MissionsScene';
import { MinigameRegistry } from '@core/registry/MinigameRegistry';

/**
 * Construye la configuracion de Phaser. Las escenas de los minijuegos se obtienen
 * dinamicamente del registry, de modo que sumar un minijuego no requiere editar
 * esta configuracion.
 */
export function createGameConfig(parent: string): Phaser.Types.Core.GameConfig {
  const minigameScenes = MinigameRegistry.list().map((definition) => definition.scene);
  const size = computeDesignSize(window.innerWidth, window.innerHeight);

  return {
    type: Phaser.AUTO,
    parent,
    backgroundColor: Palette.background,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: size.width,
      height: size.height,
    },
    input: {
      activePointers: 3,
    },
    scene: [
      BootScene,
      PreloadScene,
      HubScene,
      CharacterSelectScene,
      StoreScene,
      ScenariosScene,
      AchievementsScene,
      MissionsScene,
      ...minigameScenes,
    ],
  };
}
